"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debugLog = function (message) {
    if (typeof newrelic !== 'undefined') {
        newrelic.noticeError(JSON.stringify(message));
    }
};
exports.default = debugLog;
